import type { Option, ValueType } from '@atlaskit/select';

export const toSingleSelectValue = <T,>(value: ValueType<Option<T>>): Option<T> | null | undefined => {
    if (value == null) {
        return value;
    }
    return Array.isArray(value) ? value[0] : value;
};

export const toMultiSelectValue = <T,>(value: ValueType<Option<T>>): Option<T>[] => {
    if (value == null) {
        return [];
    }
    return Array.isArray(value) ? value : [value];
};
